@if (this.route.name != "Pseudocode") {
  <a class="item" [class.collapsed]="this.collapsed" [class.active]="this.active" [routerLink]="[this.route.route]">
    <mat-icon class="icon" [svgIcon]="this.route.name"></mat-icon>
    @if (!this.collapsed) {
      <p>{{this.route.name}}</p>
    }
  </a>
}

@if (this.route.name == "Pseudocode") {
  <div class="item" [class.collapsed]="this.collapsed" (click)="this.goToPage()">
    <mat-icon class="icon" [svgIcon]="this.route.name"></mat-icon>
    @if (!this.collapsed) {
      <p>{{this.route.name}}</p>
    }
  </div>
}
